import React, { useState } from "react";
import PropTypes from "prop-types";
import { requestPostFetchApi } from "utils/apiMethods";
import "components/Button/Button.css";
import { disablePointerEvents, enablePointerEvents } from "utils/commonMethods";
import { useSelector } from "react-redux";

//Handles all type of button available in app.
function Button({
  children,
  loaderApiKey,
  onClick = Function.prototype, //Dummy function
  inputProps = {},
  apiRequestBody = {},
  className: customClassName = "",
  name = "",
}) {
  const clDetails = useSelector((state) => state.clDetailsReducer);
  const [showLoader, setShowLoader] = useState(false);
  const onClickMiddleware = function () {
    //Do not show loader if no api key is passed.
    if (!loaderApiKey) {
      return onClick();
    }

    setShowLoader(true);
    disablePointerEvents();
    //Starts loader and send api data back to the parent component.
    requestPostFetchApi(loaderApiKey, apiRequestBody).then(
      (response) => {
        enablePointerEvents();
        setShowLoader(false);
        return onClick(response);
      },
      () => {
        enablePointerEvents();
        setShowLoader(false);
      }
    );
  };

  //Dynamically setting class name of button.
  let customButtonClassName = "custom-button outer-shadow";

  if (loaderApiKey) {
    customButtonClassName += " with-loader fcolor--secondary";
  }

  if (showLoader) {
    customButtonClassName += " show-loader";
  }

  return (
    <div className={"custom-button__wrapper " + customClassName}>
      <button
      style={{background:clDetails.secondaryColor, color:clDetails.tertiaryColor}}
        className={customButtonClassName}
        onClick={onClickMiddleware}
        name={name}
        {...inputProps}
      >
        {showLoader ? <div className="loading-dots"></div> : children}
      </button>
    </div>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  loaderApiKey: PropTypes.symbol,
  inputProps: PropTypes.object,
  apiRequestBody: PropTypes.object,
  name: PropTypes.string,
};

export default Button;
